import { AsyncReturnType } from "type-fest";

import { BillingService } from "@/services";
import { UseMutationSimpleOptions, useMutation } from "@/services/hooks";

type Variables = Parameters<typeof BillingService.createPaymentMethod>[0];
type Data = AsyncReturnType<typeof BillingService.createPaymentMethod>;
type Error = unknown;

export const useCreatePaymentMethod = <TContext = unknown>(
  options?: UseMutationSimpleOptions<Data, Error, Variables, TContext>
) => {
  const result = useMutation<Data, Error, Variables, TContext>(
    BillingService.createPaymentMethod,
    options
  );

  return result;
};
